import React from "react";

export default function Title() {
  return (
    <div className="title">
      <h1>Todo App</h1>
    </div>
  );
}
